import './TelaCarregando.css';

/**
 * Estado de espera de tela cheia, usado enquanto o painel pergunta ao
 * middleware se existe sessão.
 */
export function TelaCarregando({ mensagem }: { readonly mensagem: string }) {
  return (
    <div className="tela-carregando">
      <div className="tela-carregando__caixa" role="status">
        <span className="tela-carregando__pulso" aria-hidden="true" />
        <span className="tela-carregando__texto">{mensagem}</span>
      </div>
    </div>
  );
}
